<template>
  <div>
    <h3>Delete User</h3>
    <p>
      This permanently deletes the account and its licenses, and cancels all
      Stripe subscriptions without a refund. This action cannot be undone.
      Please type the user email to confirm: "{{ user.email }}"
    </p>
    <form @submit.prevent="deleteUser">
      <b-input v-model="confirmEmail" placeholder="User Email" autofocus />
      <div class="mt-4 text-right">
        <b-btn class="ml-2 px-4" variant="secondary" @click="$emit('cancel')">
          Cancel
        </b-btn>
        <b-btn
          :disabled="confirmEmail.trim() !== user.email || loading"
          class="ml-2 px-4"
          variant="danger"
          type="submit"
        >
          Delete
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import API from "@/api";

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    confirmEmail: "",
    loading: false
  }),

  methods: {
    async deleteUser() {
      this.loading = true;
      const { success } = await API.adminDeleteUser(this.user.id);
      this.loading = false;
      if (!success) return;

      this.$notify({
        type: "success",
        text: "User deleted"
      });
      this.$emit("deleted");
    }
  }
};
</script>
